import Cookies from "js-cookie"
import React from "react"
import { connect } from "react-redux"

import {
  facebookLogin,
  fetchLoginResult,
  setExplicitLogin,
  setLoginNotification,
  sendUserInfo,
  submitRegistration,
} from "app-store-v2/app/actions"
import { openModal } from "components/modal"
import { jewlr_link_decorator } from "helpers/analytics-helpers"
import initializeFacebook from "helpers/facebook-initialize"

// To-do: change modal dispatches and state from Redux state to local state

export default function withAuth(WrappedComponent) {
  const InternalAuth = (props) => {
    return <WrappedComponent {...props} />
  }

  const mapStateToProps = (state) => {
    return {
      // errors for the registration modal are emitted back to this prop
      error: "",
      // flag to check if user is loggedIn. If true, 'create password' field will show
      loggedIn: Object.keys(state.user.jewlrorders).length > 4,
      //set password modal state
      message: state.messages.provideUserInfo,
      //notification message displayed in login / password setup modals
      notificationMessage: state.user.loginMessage,
      // processing flag to disable the form during a submission
      processing: false,
      processingFacebook: state.user.facebook.loginState === "connecting",
      referralName: state.user.referralName,
      routerHash: state.router.location.hash,
      //|| Cookies.get("user_obj"),
      // user object for to display email
      user: state.user,
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      clearNotification: () => {
        dispatch(setLoginNotification(null))
      },
      clickForgot: (e, path) => {
        e.preventDefault()
        window.location = jewlr_link_decorator(path)
        return false
      },
      doFacebookLogin: () => {
        initializeFacebook(() => {
          // IMPORTANT: We must clear all fblo_* cookies to prevent a deadly "unknown" state from FB.getLoginStatus
          var cookies = document.cookie.split(";")
          for (var i = 0; i < cookies.length; i++) {
            if (cookies[i].split("=")[0].indexOf("fblo_") != -1) {
              Cookies.remove(cookies[i].split("=")[0].trim())
            }
          }

          FB.login(
            function (response) {
              if (response.authResponse) {
                dispatch(facebookLogin())
                submit_ga_event_click("Continue with FB", "accepted")
              } else {
                submit_ga_event_click("Continue with FB", "decline_at_login")
              }
            },
            { scope: "public_profile,email" }
          )
        })
      },
      doProvideInfo: (values, actions) => {
        dispatch(sendUserInfo(values, actions))
      },
      doSubmitRegistration: (values, actions) => {
        dispatch(submitRegistration(values, actions))
      },
      regularLogin: (values, options = {}) => {
        const params = new URL(document.location).searchParams

        var params_hash = Object.assign({}, values)
        params_hash["cart_token"] = Cookies.get(
          sl.config.cookies_config.cart_token
        )
        params_hash["wishlist_token"] = Cookies.get(
          sl.config.cookies_config.wishlist_token
        )
        // var remember_me = params_hash.remember_me
        params_hash["order_token"] = params.get("order_token")
        if (!options.implicit) {
          dispatch(setExplicitLogin())
        }
        dispatch(fetchLoginResult(params_hash, options))
      },
      resetNotification: () => {
        dispatch(setLoginNotification(null))
      },
      toAuthenticate: () => {
        openModal("#authenticate")
      },
    }
  }

  const Auth = connect(mapStateToProps, mapDispatchToProps)(InternalAuth)

  return Auth
}
